import { render, staticRenderFns } from "./Submission.vue?vue&type=template&id=60715ff8&scoped=true"
import script from "./Submission.vue?vue&type=script&lang=ts"
export * from "./Submission.vue?vue&type=script&lang=ts"
import style0 from "./Submission.vue?vue&type=style&index=0&id=60715ff8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60715ff8",
  null
  
)

export default component.exports